import { cn } from "@/lib/utils";
import { ConexusSymbol } from "./ConexusSymbol";
import { ConexusWordmark } from "./ConexusWordmark";

interface ConexusLogoProps {
  className?: string;
  variant?: "gradient" | "navy" | "white" | "black" | "blue-gradient" | "full";
  layout?: "horizontal" | "stacked" | "symbol-only" | "wordmark-only";
  size?: "sm" | "md" | "lg" | "xl";
  showSubtitle?: boolean;
  invertColors?: boolean;
}

export const ConexusLogo = ({ 
  className, 
  variant = "gradient",
  layout = "horizontal",
  size = "md",
  showSubtitle = true,
  invertColors = false
}: ConexusLogoProps) => {
  // Map 'full' variant to 'gradient' for backward compatibility
  const resolvedVariant = variant === "full" ? "gradient" : variant;
  const displayVariant = invertColors ? "white" : resolvedVariant;
  const sizeConfig = {
    sm: { symbol: 32, gap: "gap-2" },
    md: { symbol: 48, gap: "gap-3" },
    lg: { symbol: 64, gap: "gap-4" },
    xl: { symbol: 80, gap: "gap-5" },
  };

  const config = sizeConfig[size];

  if (layout === "symbol-only") {
    return (
      <div className={cn("conexus-logo", className)}>
        <ConexusSymbol variant={displayVariant} size={config.symbol} />
      </div>
    );
  }

  if (layout === "wordmark-only") {
    return (
      <div className={cn("conexus-logo", className)}>
        <ConexusWordmark variant={displayVariant} size={size} showSubtitle={showSubtitle} />
      </div>
    );
  }

  if (layout === "stacked") {
    return (
      <div className={cn("conexus-logo flex flex-col items-center", config.gap, className)}>
        <ConexusSymbol variant={displayVariant} size={config.symbol * 1.5} />
        <ConexusWordmark variant={displayVariant} size={size} showSubtitle={showSubtitle} centered />
      </div>
    );
  }

  // Horizontal layout (default)
  return (
    <div className={cn("conexus-logo flex items-center", config.gap, className)}>
      <ConexusSymbol variant={displayVariant} size={config.symbol} />
      <ConexusWordmark variant={displayVariant} size={size} showSubtitle={showSubtitle} />
    </div>
  );
};

export default ConexusLogo;
